import React from 'react';
import { Send, MessageCircle, Mail, Facebook } from 'lucide-react';
import '../styles/Home.css';

const Footer = ({ contactInfo }) => {
  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="heading-2">SKLEP</h3>
            <p className="body-small">Nowoczesny sklep internetowy - projekt demonstracyjny</p>
            <p className="body-small" style={{ marginTop: '12px', color: 'var(--text-tertiary)' }}>
              Zaprojektowany aby pokazać umiejętności tworzenia premium e-commerce
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="heading-3">Kontakt</h4>
            <div className="contact-links">
              <a 
                href="https://t.me/srwebstudio" 
                className="contact-link contact-link-primary ultra-smooth" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Send size={18} />
                <div className="contact-info">
                  <span className="contact-label">Telegram</span>
                  <span className="contact-value">{contactInfo.telegram}</span>
                </div>
              </a>
              <a 
                href="https://wa.me/48452688251" 
                className="contact-link ultra-smooth" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <MessageCircle size={18} />
                <div className="contact-info">
                  <span className="contact-label">WhatsApp</span>
                  <span className="contact-value">{contactInfo.whatsapp}</span>
                </div>
              </a>
              <a 
                href={contactInfo.facebook}
                className="contact-link ultra-smooth" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Facebook size={18} />
                <div className="contact-info">
                  <span className="contact-label">Facebook</span>
                  <span className="contact-value">@srwebstudio</span>
                </div>
              </a>
              <a 
                href="mailto:webstudiosr4@gmail.com" 
                className="contact-link ultra-smooth"
              >
                <Mail size={18} />
                <div className="contact-info">
                  <span className="contact-label">Email</span>
                  <span className="contact-value">{contactInfo.email}</span>
                </div>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="heading-3">Nawigacja</h4>
            <nav className="footer-nav">
              <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                Start
              </button>
              <button onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}>
                Produkty
              </button>
              <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}>
                O projekcie
              </button>
              <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}>
                Funkcje
              </button>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">© 2024 Sklep Demo. Projekt demonstracyjny portfolio.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
